module.exports = __webpack_public_path__ + "static/media/ResidentialStudyCourses.281fbc60.jpg";